import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet-async";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import { Link } from "react-router-dom";

function Home() {
  return (
    <>
      <Helmet>
        <title>Vedant Gaidhane | Cloud Infrastructure & DevOps Engineer</title>
        <meta
          name="description"
          content="Cloud & DevOps Engineer with 1.9+ years building, securing, and optimizing AWS infrastructure. Specializing in FinOps & cloud cost optimization, DevSecOps CI/CD, and observability."
        />
      </Helmet>
      <section className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <div className="hero-container">
            <Row className="align-items-center w-100">
              <Col lg={7} className="order-2 order-lg-1">
                {/* Badge
                <div className="hero-badge">
                  <span className="hero-badge-dot"></span>
                  Available for new opportunities
                </div> */}

                {/* Greeting */}
                <h1 style={{ paddingBottom: 6 }} className="heading">
                  Hi there!{" "}
                  <span className="wave" role="img" aria-label="wave">
                    👋🏻
                  </span>
                </h1>

                {/* Name */}
                <h1 className="heading-name">
                  I'm{" "}
                  <strong className="main-name">Vedant Gaidhane</strong>
                </h1>

                {/* Typewriter */}
                <div style={{ margin: "0.9rem 0 0.5rem" }}>
                  <Type />
                </div>

                {/* Subtitle */}
                <p className="hero-subtitle">
                  Cloud &amp; DevOps Engineer specialising in AWS infrastructure, DevSecOps
                  automation, and FinOps — helping teams cut cloud spend, ship faster, and
                  run reliable production systems.
                </p>

                {/* Stats */}
                <div className="hero-stats">
                  <div className="hero-stat">
                    <span className="hero-stat-value">$1.2M+</span>
                    <span className="hero-stat-label">Monthly AWS<br/>Spend Managed</span>
                  </div>
                  <div className="hero-stat">
                    <span className="hero-stat-value">AWS + Azure</span>
                    <span className="hero-stat-label">Multi-Cloud<br/>Platforms</span>
                  </div>
                  <div className="hero-stat">
                    <span className="hero-stat-value">24/7</span>
                    <span className="hero-stat-label">Production<br/>Monitoring</span>
                  </div>
                  <div className="hero-stat">
                    <span className="hero-stat-value">1.9+</span>
                    <span className="hero-stat-label">Years<br/>Experience</span>
                  </div>
                </div>

                {/* CTA Buttons */}
                <div className="hero-buttons">
                  <Link to="/project" className="btn-hero-primary">
                    View Projects →
                  </Link>
                  <Link to="/resume" className="btn-hero-secondary">
                    Download Resume
                  </Link>
                </div>
              </Col>

              <Col lg={5} className="order-1 order-lg-2 myAvtar">
                {/* Terminal window decorative element */}
                <div
                  style={{
                    background: "rgba(255,255,255,0.03)",
                    border: "1px solid rgba(108,99,255,0.20)",
                    borderRadius: "16px",
                    padding: "0",
                    backdropFilter: "blur(12px)",
                    overflow: "hidden",
                    maxWidth: "420px",
                    width: "100%",
                  }}
                >
                  {/* Terminal title bar */}
                  <div
                    style={{
                      background: "rgba(255,255,255,0.05)",
                      borderBottom: "1px solid rgba(108,99,255,0.15)",
                      padding: "10px 16px",
                      display: "flex",
                      alignItems: "center",
                      gap: "7px",
                    }}
                  >
                    <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#ff5f56", display: "inline-block" }}></span>
                    <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#ffbd2e", display: "inline-block" }}></span>
                    <span style={{ width: 10, height: 10, borderRadius: "50%", background: "#27c93f", display: "inline-block" }}></span>
                    <span style={{ marginLeft: "auto", fontSize: "0.72rem", color: "rgba(255,255,255,0.35)", fontFamily: "var(--mono, monospace)" }}>
                      vedant@devops ~ $
                    </span>
                  </div>
                  {/* Terminal body */}
                  <div
                    style={{
                      padding: "1.4rem 1.5rem 1.6rem",
                      fontFamily: "'Fira Code', 'Fira Mono', monospace",
                      fontSize: "0.82rem",
                      lineHeight: "1.9",
                      color: "rgba(255,255,255,0.75)",
                    }}
                  >
                    <div><span style={{ color: "#00d4aa" }}>$</span> whoami</div>
                    <div style={{ color: "#6c63ff", marginBottom: "0.6rem" }}>vedant-gaidhane</div>

                    <div><span style={{ color: "#00d4aa" }}>$</span> cat expertise.txt</div>
                    <div style={{ color: "rgba(255,255,255,0.55)", marginBottom: "0.6rem" }}>
                      AWS · Azure · FinOps<br/>
                      Terraform · Kubernetes · Jenkins<br/>
                      GuardDuty · WAF · CloudTrail
                    </div>

                    <div><span style={{ color: "#00d4aa" }}>$</span> echo $IMPACT</div>
                    <div style={{ color: "#00d4aa" }}>
                      $1.2M+ monthly AWS spend optimised ✓
                      <br/>
                      Automated DevSecOps CI/CD delivered ✓
                    </div>

                    <div style={{ marginTop: "0.6rem" }}>
                      <span style={{ color: "#00d4aa" }}>$</span>{" "}
                      <span style={{ animation: "blink-term 1s step-end infinite", display: "inline-block", width: 8, height: "1em", background: "#6c63ff", verticalAlign: "text-bottom" }}></span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      <Home2 />
      <style>{`
        @keyframes blink-term {
          0%,100% { opacity: 1; }
          50% { opacity: 0; }
        }
      `}</style>
    </>
  );
}

export default Home;
